module.exports = __webpack_public_path__ + "static/13-formation-deformation-s-xv-d6d6f83284acf7c3684b89289019e28a.jpg";